<template>
    <Header>
        <template v-slot:title>
            <h1>{{ $e('Your Workflows') }}<a href="https://optimizelink.com/flow" class="opui-headline-helplink opui-fa opui-fa-question-circle-o" target="_blank"></a></h1>
        </template>

        <template v-slot:right-menu-buttons>
            <router-link to="/workflows/create" class="opui-btn opui-btn-primary">
                {{ $e('Create New Workflow') }}
            </router-link>
        </template>
    </Header>
    <Transition>
        <main class="opui-main opui-pt-7">
            <div class="opui-container opui-max-900" v-if="loaded">
                <div class="opui-item-list op-flow-workflow-list" v-if="workflows && workflows.length > 0">
                    <ul>
                        <li v-for="workflow in workflows" :key="workflow.id">
                            <transition-group name="workflow-fade">
                                <ListItem :workflow="workflow" @deleted="workflowDeleted" @duplicated="workflowDuplicated" />
                            </transition-group>
                        </li>
                    </ul>
                </div>

                <div class="opui-empty-list" v-else>
                    <div class="opui-d-flex opui-align-items-center">
                        <div class="opui-empty-list-media">
                            <img width="450" height="314" :src="this.imgUrl('flows.svg')" alt="Workflows" />
                        </div>
                        <div class="opui-empty-list-text">
                            <h2>{{ $e('Use Workflows to automate processes on your WordPress Website') }}</h2>
                            <p>
                                {{ $e('Workflows allow you to automate processes when certain events happen on your website.') }}
                                <a href="https://optimizelink.com/flow" target="_blank">{{ $e('Learn more') }}</a>
                            </p>
                            <router-link to="/workflows/create" class="opui-btn opui-btn-primary">
                                {{ $e('Create New Workflow') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="opui-container opui-max-900">
                <ItemListIsLoading :itemRows="5" />
            </div>
        </main>
    </Transition>
</template>

<script>
import { useSettingsStore } from "../store/settings"
import { mapStores } from 'pinia'
import Header from "../components/Global/Header.vue"
import ListItem from "../components/Workflows/ListItem.vue"
import ItemListIsLoading from "../components/Loading/ItemListIsLoading.vue"
export default {
    components: { Header, ListItem, ItemListIsLoading },
    computed: {
        ...mapStores(useSettingsStore),
    },
    data() {
        return {
            workflows: [],
            loaded:    false,
        }
    },
    created() {
        this.loadInitialData()
    },
    methods: {
        async loadInitialData() {
            let response = await this.$http.get('workflows')
            let status   = await response.status

            if (status === 200) {
                this.workflows = await response.data.data
            } else {
                console.info('Error when fetching workflows.', response.data)
            }

            this.loaded = true
        },

        workflowDeleted(workflow) {
            this.workflows = this.workflows.filter((value, index, arr) => {
                return value.id !== workflow.id
            })
        },

        workflowDuplicated(id) {
            this.loadInitialData()
        },

        createNewWorkflow() {
            alert("NEW")
        }
    }
}
</script>

<style scoped>
.workflow-fade-enter,
.workflow-fade-leave-to {
    opacity: 0;
}

.workflow-fade-enter {
    transform: translateY(30%);
}

.workflow-fade-leave-to {
    transform: translateX(30%);
}

.workflow-fade-enter-active,
.workflow-fade-leave-active {
    transition: all .3s;
}

.workflow-fade-move {
    transition: all .3s;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.1s ease-in-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
